import React, { useState, useEffect, useMemo } from 'react';
import { useChatContext } from 'stream-chat-react';
import { getOtherParticipants } from 'utils';
import { Channel as ChannelType } from 'stream-chat';
import { ChannelType as BBChannelType } from 'contexts';
import { Avatar } from '../Avatar';
import { ListingImage } from '../ListingImage';
import { AVATAR_CHANNEL_LIST_SIZE } from '../../app/ContextualChat/constants';

const ChannelThumbnail: React.FC<{
  channel: ChannelType;
}> = ({ channel }) => {
  const { listingThumbnail } = channel.data;
  const { client } = useChatContext();

  const avatarChatMember = useMemo(
    () => getOtherParticipants(channel, client.userID)[0],
    [client.userID, channel],
  );

  const avatarChatMemberNames = useMemo(
    () => ({
      firstName: avatarChatMember.name?.split(' ').at(0) || '',
      lastName: avatarChatMember.name?.split(' ').at(1) || '',
    }),
    [avatarChatMember],
  );

  if (channel.data?.type === BBChannelType.listing) {
    return (
      <ListingImage
        imageSrc={listingThumbnail}
        size={AVATAR_CHANNEL_LIST_SIZE}
      />
    );
  }
  return (
    <Avatar
      user={{
        ...avatarChatMember,
        ...avatarChatMemberNames,
      }}
      width={AVATAR_CHANNEL_LIST_SIZE}
    />
  );
};

export default ChannelThumbnail;
